// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3vMz_","left":"InfoRow_left__1fiWG"};